import React from 'react';
import { Flex, Text, useColorMode } from '@chakra-ui/react';
import { formatTime, peso, priceStx } from 'utils/utility';
import { bgColor } from 'config/data';

const CurrentBid = ({ auction, finish, price_micro_stx, price_usd, days, hours, minutes, seconds }) => {
  const { colorMode } = useColorMode();
  return (
    <Flex
      w={{ base: '100%', md: '100%' }}
      bg={bgColor[colorMode]}
      borderWidth={colorMode === 'dark' ? 0 : 1}
      borderRadius="12px"
      p={{ base: '10px 20px', md: '25px 30px' }}
      id="bid"
      mb="20px"
    >
      <Flex
        id="current"
        borderRight={1}
        borderColor={{ base: '#F7F7F7', md: '#cecece' }}
        borderStyle="dashed"
        flexDirection="column"
        fontSize="14px"
        pr={{ base: 0, md: '20px' }}
        w="143px"
      >
        <Text>Current bid</Text>
        <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px">
          {auction?.highest_bid === null ? peso(price_usd) : peso(auction?.highest_bid?.amount / 100)}
        </Text>
        <Text>
          {auction?.highest_bid === null ? priceStx(price_micro_stx) : priceStx(auction?.highest_bid?.amount_micro_stx)}
        </Text>
      </Flex>
      <Flex id="ending" fontSize="14px" flexDirection="column" flex="2" pl={{ base: '5px', md: '25px' }}>
        <Text>Auction ending in</Text>
        <Flex flex="1">
          {days > 0 && (
            <Flex id="day" flexDirection="column" pr={{ base: 0, md: '12px' }}>
              <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px">
                {formatTime(days)} {'     '}:
              </Text>
              <Text>{days > 1 ? 'Days' : 'Day'}</Text>
            </Flex>
          )}
          <Flex id="hour" flexDirection="column" pr={{ base: 0, md: '12px' }}>
            <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px">
              {formatTime(hours)} {'     '}:
            </Text>
            <Text>Hrs</Text>
          </Flex>
          <Flex id="minutes" flexDirection="column" pr={{ base: 0, md: '12px' }}>
            <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px">
              {formatTime(minutes)} :
            </Text>
            <Text>Mins</Text>
          </Flex>
          <Flex id="secs" flexDirection="column">
            <Text fontSize={finish ? '20px' : '24px'} fontWeight="bold" py="10px">
              {formatTime(seconds)}
            </Text>
            <Text>Secs</Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CurrentBid;
